import { render, staticRenderFns } from "./DeLiveryMaterialList.vue?vue&type=template&id=a52c9e54&scoped=true"
import script from "./DeLiveryMaterialList.vue?vue&type=script&lang=js"
export * from "./DeLiveryMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c9e54",
  null
  
)

export default component.exports